import { match } from "ts-pattern";
import { useTranslation } from "@i18n/hooks";
import { RecipeVariantProps } from "@styled-system/types";
import { badgeClass } from "./environment-badge.styles";
import {
	appEnvironment,
	isDevelopment,
	isRunningAgainstProduction,
	isRunningAgainstStaging,
} from "../../environment";

const environment = appEnvironment;

type RecipeEnvironmentType = NonNullable<RecipeVariantProps<typeof badgeClass>>["environment"];

const isDevelopmentWithProductionApi = isDevelopment && isRunningAgainstProduction();
const isDevelopmentWithStagingApi = isDevelopment && isRunningAgainstStaging();

export const EnvironmentBadge = () => {
	const { t } = useTranslation("common");

	const environmentType = match({
		isDev: isDevelopment,
		environment,
		isDevelopmentWithProductionApi,
		isDevelopmentWithStagingApi,
	})
		.returnType<{ type: RecipeEnvironmentType; label: string }>()
		.with({ isDevelopmentWithProductionApi: true, isDevelopmentWithStagingApi: false }, () => ({
			type: "warning",
			label: t("environment.devAgainstProduction"),
		}))
		.with({ isDevelopmentWithProductionApi: false, isDevelopmentWithStagingApi: true }, () => ({
			type: "warning",
			label: t("environment.devAgainstStaging"),
		}))
		.with({ isDev: false, environment: "production" }, () => ({
			type: "production",
			label: t("environment.production"),
		}))
		.with({ isDev: false, environment: "staging" }, () => ({
			type: "staging",
			label: t("environment.staging"),
		}))
		.with({ isDev: true }, { environment: "development" }, { environment: "dev" }, () => ({
			type: "development",
			label: t("environment.local"),
		}))
		.exhaustive();

	return (
		<div className={badgeClass({ environment: environmentType.type })}>
			{environmentType.label}
		</div>
	);
};
